import React from 'react';
import { DatabaseIcon, BotIcon, TargetIcon, PenLineIcon, SendIcon, BarChart3Icon, SlidersIcon } from 'lucide-react';
const features = [{
  name: 'Natural language queries',
  description: 'Stop wrestling with complex filters. Just describe what you want in plain English, like "Find dentists in Ohio with poor reviews."',
  icon: BotIcon
}, {
  name: '200M+ local businesses',
  description: 'Natively connected to a massive database of 200M+ local businesses, complete with verified owner contact info.',
  icon: DatabaseIcon
}, {
  name: 'Lead scoring across 4 dimensions',
  description: 'Each lead is scored across revenue potential, intent to buy, ICP match, and tech readiness. Based on your priorities, we assign different weights to each dimension so your highest-value leads always surface first.',
  icon: TargetIcon
}, {
  name: 'Personalized outreach emails',
  description: "The agent doesn't just find leads; it writes personalized emails for each one, referencing specific data points like their location count, recent reviews, or growth trajectory.",
  icon: PenLineIcon
}, {
  name: 'Built-in email sequencing',
  description: 'Launch multi-step email sequences directly from your approved lead lists. Schedule follow-ups, track opens and replies, and pause threads automatically — all without leaving Openmart.',
  icon: SendIcon
}, {
  name: 'Actionable deliverables',
  description: 'Get structured outputs including scored lead CSVs with dimension breakdowns, personalized email drafts for each contact, and market analysis summaries in a clean working folder.',
  icon: BarChart3Icon
}];
export function OpenclawFeatures() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5465">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-12 lg:p-16 relative overflow-hidden" data-id="element-5466">
        <div className="max-w-2xl lg:text-center mx-auto mb-16" data-id="element-5467">
          <div className="text-sm font-bold leading-7 text-blue-600 uppercase tracking-wider mb-2" data-id="element-5468">
            Capabilities
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-5469">
            Everything your AI sales agent can do
          </h2>
          <p className="text-lg leading-relaxed text-slate-500" data-id="element-5470">
            Our AI sales agent combines advanced language models with the
            world's most comprehensive local business database to automate your
            entire top-of-funnel workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-5471">
          {features.map(feature => <div key={feature.name} className="bg-slate-50 p-8 rounded-3xl border border-slate-100 hover:border-blue-200 hover:shadow-md transition-all flex flex-col" data-id="element-5472">
              <div className="h-12 w-12 flex items-center justify-center rounded-xl bg-white border border-slate-200 mb-6 shadow-sm" data-id="element-5473">
                <feature.icon className="h-6 w-6 text-blue-600" data-id="element-5474" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-5475">
                {feature.name}
              </h3>
              <p className="text-slate-500 leading-relaxed flex-1" data-id="element-5476">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}